module.exports = __webpack_public_path__ + "static/media/dinersclub.ed9440ac.svg";